import React, { useState, useMemo, useEffect } from "react";
import MaterialTable from 'material-table';
import EditIcon from '@material-ui/icons/Edit';
import VisibilityIcon from '@material-ui/icons/Visibility';
import { Grid, Input, NativeSelect, Paper, Button } from '@material-ui/core';
import Pagination from 'react-js-pagination';
import { Link, useHistory } from 'react-router-dom';
import { getPermissions } from '../../services/auth'
import Header from "../../layout/Header";
import Subheader from "../../layout/Subheader";
import Loading from '../../components/Loading';
import api from '../../services/api';
import { findPermission, TOKEN_PAGINATION } from '../../services/auth';
import useStyles from "./style";
import './pagination.style.css';
import CloseIcon from '@material-ui/icons/Close';
import { useMessageBox } from '../../context/MessageBox';

export function Platforms() {
  const classes = useStyles();
  const history = useHistory();
  const { setMessageData } = useMessageBox();
  const [isLoading, setLoading] = useState(true);
  const [platforms, setPlatforms] = useState([]);
  const [status, setStatus] = useState('ativo');
  const [currentPage, setCurrentPage] = useState(1);
  const [itensPerPage, setItensPerPage] = useState(50);
  const [pagination, setPagination] = useState([]);
  const [openModalFilter, setModalFilter] = useState(false);

  const memoizedTable = useMemo(
    () => (
      <MaterialTable
        className={classes.table}
        options={{
          showTitle: false,
          search: false,
          toolbar: false,
          headerStyle: {
            backgroundColor: '#F5F5F5',
            textTransform: 'none',
            fontSize: '15px',
          },
          filtering: true,
          paging: false,
          showEmptyDataSourceMessage: false
        }}
        onRowClick={(event, rowData) => {
          if(!!findPermission(1146, 'Alterar')) {
            window.location.href = window.location.origin + `/app/plataforma/${rowData.plataformaId}/editar`
          }
        }}
        title="Multiple Actions Preview"
        columns={[
          {
            title: 'Plataforma',
            field: 'plataforma',
            cellStyle: {
              fontSize: '13px',
              padding: '8px 16px',
            },
          },
          {
            title: 'Surpervisor',
            field: 'supervisor',
            cellStyle: {
              fontSize: '13px',
              padding: '8px 16px',
            },
          },
          {
            title: 'Status',
            field: 'status',
            cellStyle: {
              fontSize: '13px',
              padding: '8px 10px',
              width: '250px',
            },
          },
          {
            title: 'Ações',
            field: 'actions',
            headerStyle: {
              textAlign: 'center',
            },
            cellStyle: {
              fontSize: '13px',
              textAlign: 'center',
              padding: '8px 16px',
            },
            filtering: false,
            sorting: false,
            disableClick: true,
            render: (rowData) => (
              <>
                {!!findPermission(1146, 'Consultar') && (
                  <Link
                    className={classes.buttonVisualize}
                    to={`/app/plataforma/${rowData.plataformaId}/visualizar`}
                  >
                    <VisibilityIcon style={{ fontSize: 30, color: '#4AAF05' }} />
                  </Link>
                )}
                {!!findPermission(1146, 'Alterar') && (
                  <Link
                    className={classes.buttonEdit}
                    to={`/app/plataforma/${rowData.plataformaId}/editar`}
                  >
                    <EditIcon style={{ fontSize: 30, color: '#FB8832' }} />
                  </Link>
                )}
              </>
            ),
          },
        ]}
        data={platforms}
      />
    ),
    [platforms],
  );

  const fetchPlataforms = async (
    pageNumber = currentPage,
    currentlyStatus = status,
  ) => {
    setLoading(true);
    const res = await api.get(
      `Plataformas/Consultar?itensPorPagina=${itensPerPage}&paginaInicial=${pageNumber}&status=${currentlyStatus}`,
    );

    if (res?.data?.complemento?.mensagensBox?.length > 0) {
      setMessageData(res?.data?.complemento?.mensagensBox);
    }

    if (res.data.status !== 'Sucesso') {
      if (res.data.resposta) {
        if (res.data.resposta.length > 0) {
          res.data.resposta.forEach((element) => {
            toast.error(element.message);
          });

          return;
        }
      }
    }

    setPagination(res.data.paginacao);
    if(res.data.paginacao.qtdTotalRegistros > 0){
      setPlatforms(res.data.resposta);
    } else {
      setPlatforms([]);
    }
    setLoading(false);
  };


  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
    fetchPlataforms(pageNumber);
  };

  useEffect(async () => {
    const userPage = JSON.parse(sessionStorage.getItem(TOKEN_PAGINATION)).paginacao.itensPorPagina;
    setItensPerPage(userPage === 0 ? 50 : userPage);
  }, []);

  useEffect(() => {
    setCurrentPage(1);
    const delayDebounceFn = setTimeout(() => {
        fetchPlataforms();
    }, 1500);

    return () => clearTimeout(delayDebounceFn);
  }, [itensPerPage]);

  return (
    <div className={classes.root}>
        <Header />
        <Subheader 
            title='Plataformas'
            back="/app/home"
        />
      <div className={classes.content}>
        <div className={classes.tableRoot}>
            <div className={classes.actions}>
              <Button
                  variant="contained"
                  onClick={() => setModalFilter(!openModalFilter)}
                  className={classes.button}
                >
                  <span>Filtros</span>
                </Button>
                {!!findPermission(1146, 'Cadastrar') && (
                  <Link className={classes.button} to="/app/plataforma/cadastrar">
                    Novo Item
                  </Link>
                )}
                {openModalFilter && (
                  <div className={classes.filtersBox}>
                    <div className={classes.headFilter}>
                      <span className={classes.labelFilter}>Status:</span>
                      <button
                        className={classes.buttonClose}
                        onClick={() => setModalFilter(!openModalFilter)}
                      >
                        <CloseIcon style={{ fontSize: 25, color: '#fff' }} />
                      </button>
                    </div>
                    <select
                      onChange={(event) => setStatus(event.target.value)}
                      value={status}
                      className={classes.selectStatus}
                    >
                      <option value="">Todos</option>
                      <option value="ativo">Ativo</option>
                      <option value="inativo">Inativo</option>
                    </select>
                    <button
                      className={classes.buttonFilter}
                      onClick={() => fetchPlataforms(1)}
                    >
                      Aplicar Filtro
                    </button>
                  </div>
                )}
            </div>
            {isLoading ? (
                <Loading />
            ) : (
                <>
                    {memoizedTable}
                    <div className="footer-table">
                        <Pagination
                            activePage={currentPage}
                            itemsCountPerPage={itensPerPage}
                            totalItemsCount={pagination.qtdTotalRegistros}
                            pageRangeDisplayed={5}
                            onChange={handlePageChange}
                        />
                        <div className="select-page">
                            <label>Qtd. por página</label>
                            <NativeSelect
                                onChange={(e) => setItensPerPage(Number(e.currentTarget.value))}
                                value={itensPerPage}
                            >
                                <option value="25">25</option>
                                <option value="50">50</option>
                                <option value="100">100</option>
                                <option value="200">200</option>
                            </NativeSelect>
                        </div>
                    </div>
                </>
            )}
        </div>
      </div>
    </div>
  );
}
